import { render, staticRenderFns } from "./ChangeHome.html?vue&type=template&id=7347084f&scoped=true&"
import script from "./ChangeHome.vue?vue&type=script&lang=js&"
export * from "./ChangeHome.vue?vue&type=script&lang=js&"
import style0 from "./ChangeHome.scss?vue&type=style&index=0&id=7347084f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7347084f",
  null
  
)

export default component.exports